import { SCOPES } from '../api';
import type { NavNode } from '@nyce/admin-kit/console';

const r = SCOPES.billingRead;

/** The Billing group's pages, in screen order (children of its node in `NAV`). */
export const BILLING_NAV: NavNode[] = [
  {
    path: '/billing/reports',
    label: 'Reports',
    requires: r,
    description: 'Run a billing report for a period: preview, PDF and Excel, send.',
  },
  {
    path: '/billing/schedules',
    label: 'Schedules',
    requires: r,
    description: 'Reports mailed to recipients on a schedule (default: the previous month).',
  },
  {
    path: '/billing/runs',
    label: 'History',
    requires: r,
    description: 'Every report run and where it was sent: download or send again.',
  },
];
